import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createBrowserHistory } from 'history'
import combinedReducer from '../reducers'
import PageMiddleware from '../middlewares/pageMiddleware'

// Browser history (used by Router and middleware)
const history = createBrowserHistory()

// Redux store (no router state)
const store = createStore(
  combinedReducer,
  {},
  applyMiddleware(createLogger(), PageMiddleware(history), thunk)
)

export { store, history }